export default "__VITE_ASSET__b8d51e2d__"